import { SubscriptionOverview } from './SubscriptionOverview'

export const General = () => {
  return <SubscriptionOverview />
}
